// A line of details, e.g. under a row's title: "Rechnung · R-2026-01 · 3. Sept. 2026". Empty parts are left out.
export const joinDetails = (parts: (string | null | false | undefined)[]) => parts.filter(Boolean).join(' · ');
